if (!customElements.get('cushion-color-drawer')) {
  class CushionColorDrawer extends HTMLElement {
    constructor() {
      super();
      this.fabricsData = {};
    }

    connectedCallback() {
      // Parse data
      const dataScript = this.querySelector('script[data-fabric-data]');
      if (dataScript) {
        try {
          this.fabricsData = JSON.parse(dataScript.textContent);
        } catch (e) {
          console.error('Failed to parse fabric data', e);
        }
      }

      this.optionPosition = this.getAttribute('data-option-position') || '1';
      this.init();
    }

    init() {
      this.selectedImg = this.querySelector('.js-selected-fabric-image-swatch');
      this.selectedTitle = this.querySelector('.js-selected-title');
      this.selectedMainInfo = this.querySelector('.js-main-info');
      this.selectedInfo = this.querySelector('.js-selected-info');
      this.selectedWash = this.querySelector('.js-selected-wash-icons');
      this.selectedWR = this.querySelector('.js-selected-water-repellent');
      this.selectedOT = this.querySelector('.js-selected-oeka');
      this.chooseBtn = this.querySelector('.js-choose-fabric');
      this.templates = this.querySelector('.js-fabric-data-templates');

      // Swatch click listeners
      this.querySelectorAll('.js-drawer-swatch').forEach(swatch => {
        swatch.addEventListener('click', () => {
          this.updateDrawerSelection(swatch.dataset.fabricTitle);
        });
      });

      // Choose fabric button logic
      if (this.chooseBtn) {
        this.chooseBtn.addEventListener('click', () => {
          const title = this.chooseBtn.dataset.fabric;
          this.handleChooseFabric(title);
        });
      }
    }

    updateDrawerSelection(title) {
      const fabric = this.fabricsData[title];
      const tpl = this.templates.querySelector(`[data-fabric-title="${title}"]`);
      if (!fabric || !tpl) return;

      // Update top section
      if (this.selectedImg) {
        if (fabric.img) this.selectedImg.style.backgroundImage = `url('${fabric.img}')`;
        else this.selectedImg.style.backgroundImage = 'none';
      }
      if (this.selectedTitle) this.selectedTitle.textContent = fabric.title;
      if (this.selectedMainInfo) this.selectedMainInfo.innerHTML = tpl.querySelector('.tpl-main-info') ? tpl.querySelector('.tpl-main-info').innerHTML : '';
      if (this.selectedInfo) this.selectedInfo.innerHTML = tpl.querySelector('.tpl-info') ? tpl.querySelector('.tpl-info').innerHTML : '';
      if (this.selectedWash) this.selectedWash.innerHTML = tpl.querySelector('.tpl-wash') ? tpl.querySelector('.tpl-wash').innerHTML : '';

      // Update pictos
      if (this.selectedWR) this.selectedWR.classList.toggle('hide', !fabric.water_repellent);
      if (this.selectedOT) this.selectedOT.classList.toggle('hide', !fabric.oeko_tex);

      // Update active class on grid
      this.querySelectorAll('.js-drawer-swatch').forEach(s => {
        s.classList.toggle('active', s.dataset.fabricTitle === title);
      });

      // Update button data
      if (this.chooseBtn) this.chooseBtn.dataset.fabric = title;

      // Let the estimated-delivery script re-render the drawer's delivery line
      // for the previewed fabric (the variant does not change until "Choose fabric").
      document.dispatchEvent(new CustomEvent('cushion-drawer:preview', {
        detail: { title: title, optionPosition: this.optionPosition }
      }));
    }

    handleChooseFabric(title) {
      const getLabelText = (input) => {
        let text = "";
        const labelWrap = input.closest("label");
        if (labelWrap) text = labelWrap.textContent.trim().toLowerCase();
        else {
          const docLabel = document.querySelector(`label[for="${input.id}"]`);
          if (docLabel) text = docLabel.textContent.trim().toLowerCase();
          else if (input.nextElementSibling && (input.nextElementSibling.tagName === "LABEL" || input.nextElementSibling.tagName === "A")) {
            text = input.nextElementSibling.textContent.trim().toLowerCase();
          }
        }
        return text;
      };

      // Find the variant picker swatch with this value and trigger a change
      const inputs = document.querySelectorAll(`variant-picker input[data-option-position="${this.optionPosition}"]`);
      const targetTitle = title.trim().toLowerCase();
      const variantInput = Array.from(inputs).find(inp => getLabelText(inp) === targetTitle);

      if (variantInput) {
        // Close the drawer (an x-drawer element) smoothly first
        const drawer = this.closest('x-drawer');
        if (drawer && typeof drawer.hide === 'function') {
          drawer.hide();
          
          // Wait for the drawer exit animation before dispatching the change event
          // to prevent abrupt DOM replacement bugs while the drawer is still visible.
          setTimeout(() => {
            variantInput.checked = true;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }, 350);
        } else {
          // Dispatch synthetic event immediately if no drawer found
          variantInput.checked = true;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        console.warn('Could not find variant swatch for:', title, 'at position:', this.optionPosition);
      }
    }
  }

  customElements.define('cushion-color-drawer', CushionColorDrawer);
}
